
<ion-card class="headmodal">
    <span class="titlemodal">
      {{date | date: 'dd MMMM yyyy'}}
    </span>
    <!-- <ion-button class="close-button" (click)="closeModal()"> -->
        <!-- <ion-icon color="primary" name="close"></ion-icon> -->
           <ion-button class="close-button" (click)="closeModal()">
      <ion-icon color="dark" name="close-outline"></ion-icon>
      
  </ion-button>
        <!-- <app-button class="buttonV1" [iconSrc]="'../../../assets/svg/close.svg'" (buttonClick)="closeModal()" color="primary">
</app-button> -->
    <!-- </ion-button> -->
  </ion-card >
<ion-card class="contentcard bg-light">
    <ng-container *ngIf="!loader;else loadSkeleton">
        <ng-container *ngIf="selectedFood.length > 0;else noFoodBooked">
            <ion-list lines="none">
                <ng-container *ngFor="let item of selectedFood">

                    <!-- <ion-card>
                        <ion-item>
                            <ion-thumbnail slot="start">
                                <ion-img [src]="item.attachment"></ion-img>
                            </ion-thumbnail>
                            <ion-label>
                                <h3>
                                    <ng-container *ngIf="settings?.appLanguage === 'ar';else enName">
                                        {{item.a_name}}
                                    </ng-container>
                                    <ng-template #enName>
                                        {{item.name}}
                                    </ng-template>
                                    <ion-button fill="clear" (click)="clearOne(item)">
                                        <ion-icon class="modalicon" src="../../../assets/svg/trash.svg"></ion-icon>
                                    </ion-button>
                                </h3>
                                <p>
                                    <small>
                                        <ng-container *ngIf="settings?.appLanguage === 'ar';else enDesc">
                                            {{item.a_description}}
                                        </ng-container>
                                        <ng-template #enDesc>
                                            {{item.description}}
                                        </ng-template>
                                    </small>
                                </p>
                                <p>
                                    <ion-note class="ion-text-capitalize" color="tertiary">
                                        {{item.food_type_category}}
                                    </ion-note>
                                    <span class="ion-float-end">
                                        <rating [(ngModel)]="item.my_rating" readOnly="true" max="5"
                                            emptyStarIconName="star-outline" halfStarIconName="star-half"
                                            starIconName="star" nullable="false">
                                        </rating>
                                         <ion-rating [rate]="item.menu.rating" [readonly]="true" class="small"></ion-rating>
                                    </span>
                                </p>
                            </ion-label>
                        </ion-item>

                        <ion-card-header class="ion-no-padding">
                            <ion-row>
                                <ion-col size="3">{{"calories" | translate}}<br>{{item.calories}}</ion-col>
                                <ion-col size="3">{{"protein" | translate}}<br>{{item.protein}}</ion-col>
                                <ion-col size="3">{{"carbs" | translate}}<br>{{item.carbs}}</ion-col>
                                <ion-col size="3">{{"fats" | translate}}<br>{{item.fats}}</ion-col>
                            </ion-row>
                        </ion-card-header>

                    </ion-card> -->
  <!-- <menu-item 
                            class="animer"
                            [item]="item"
                            [isForceFixedMenu]="isForceFixedMenu"
                            [is_variable_carbs]="is_variable_carbs"
                            [typeFood]="typeFood"
                            (minusClickEvent)="minusQty($event)"
                            (menuDetailEvent)="menuDetailPage($event)"       
                            (plusClickEvent)="plusQty($event.item, $event.typeFood)"
                            (selectFoodMenuEvent)="selectFoodMenu($event.item, $event.typeFood)"
                            (selectCarbEvent)="selectCarb($event.carbs, $event.item)">
                            </menu-item> -->
                    <ion-card class="grid__item selected-food">
                        <div class="innercard">
                      
                      
                      
                          <div class="action-slot" >
                              <ion-chip class="mainchip">
                              
                                  <!-- <ion-note>
                                      {{"cal" | translate}}
                                  </ion-note>
                                  <ion-note>
                                      {{item.calories ? getParseFloat(item.calories) : 0}}
                                  </ion-note> -->
                              
                              <ng-container
                              *ngIf="item.food_type_category === 'meal';else snackMenu">
                              <ion-note>{{"meals" | translate}}</ion-note>
                              &nbsp;
                              </ng-container>
                              
                              <ng-template #snackMenu>
                              <ion-note>{{"snacks" | translate}}</ion-note>
                              &nbsp;
                              </ng-template>
                              </ion-chip>
                      
                          </div>
                      <div class="imgcontainer">
                          <ion-thumbnail class="imgwrapper"  >

                            <ng-container *ngIf="item.attachment;else dummyImage">
                              <ion-img
                                class="menu-image"
                                [src]="item.attachment"></ion-img>
                            </ng-container>
                            <ng-template #dummyImage>
                              <ion-img
                                class="menu-image"
                                src="../../assets/dummy.png"></ion-img>
                            </ng-template>
                          </ion-thumbnail>

                      </div>
                      <div class="contentOut">
                      <div  (click)="clearOne(item)" class="removeBtn">
                        <ion-icon class="modalicon" src="../../../assets/svg/trash.svg"></ion-icon>
                      </div>
                      <div class="bottom">
                      <div class="content"  >
                          
                          <ion-label class="menuname">
                                  <ng-container *ngIf="settings?.appLanguage === 'ar';else engTtile">
                                    {{item.a_name}}
                                  </ng-container>
                                  <ng-template #engTtile> {{item.name}} </ng-template>
                              </ion-label>

                           
                      
                  
                         
                    </div>
                      <macros-bar [item]="item" color="primary"></macros-bar>   
                          <!-- <div class="macrowrap">
                            <div class="macrolist">
                              
                              
                              <div class="kcal macro">
                                <div class="macroname">{{"cal" | translate}}</div>
                                <div class="macroval">
                                  {{item.calories ? getParseFloat(item.calories) : 0}}
                                </div>
                              </div>
                  
                              <div class="macrop macro">
                                <div class="macroname">{{"p" | translate}}</div>
                                <div class="macroval">
                                  {{item.protein ? getParseFloat(item.protein) : 0}}
                                </div>
                              </div>
                  
                              <div class="macroc macro">
                                <div class="macroname">{{"c" | translate}}</div>
                                <div class="macroval">
                                  {{item.carbs ? getParseFloat(item.carbs) : 0}}
                                </div>
                              </div>
                  
                              <div class="macrof macro">
                                <div class="macroname">{{"f" | translate}}</div>
                                <div class="macroval">
                                  {{item.fats ? getParseFloat(item.fats) : 0}}
                                </div>
                              </div>
                  
                            </div>
                          </div> -->
                        </div>
                          
                    </div>
                          
                      </div>
           
                                                          </ion-card>
                      
                </ng-container>
            </ion-list>
        </ng-container>
        <ng-template #noFoodBooked>
            <ion-card class="openclear">
                <p>
                    <ion-icon name="alert-circle-outline" color="secondary"></ion-icon>
                </p>
                <ion-label color="dark">{{"no_food_order_find_in_this_date" | translate }}</ion-label>
            </ion-card>
        </ng-template>
    </ng-container>
    <ng-template #loadSkeleton>
        <div class="typing-indicator">
			<div class="typing-circle"></div>
			<div class="typing-circle"></div>
			<div class="typing-circle"></div>
			<div class="typing-shadow"></div>
			<div class="typing-shadow"></div>
			<div class="typing-shadow"></div>
		</div>
    </ng-template>
</ion-card>
<ion-footer>
    <ion-card class="headmodal">
        <!-- <ion-row> -->
            <!-- <ion-col size="6"> -->
                <ion-button class="dark-button"
                    (click)="selectedFood.length > 0 ? clearAllSelection() : closeModal()">
                    <ng-container *ngIf="selectedFood.length > 0;else closeThisModal">
                        {{"clear_all_selection" | translate}}
                    </ng-container>
                    <ng-template #closeThisModal>
                        {{"close" | translate}}
                    </ng-template>
                </ion-button>
            <!-- </ion-col> -->
            <!-- <ion-col size="6"> -->
                <ion-button class="light-button" (click)="navigateToMenu()">
                    {{"go_to_menu" | translate}}
                </ion-button>
            <!-- </ion-col> -->
        <!-- </ion-row> -->
    </ion-card>
</ion-footer>